export const SiteFooter = () => (
  <footer className="border-t border-[var(--rule)] mt-24">
    <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col sm:flex-row gap-3 justify-between items-start sm:items-center">
      <span className="font-serif-d text-base">PDF Review</span>
      <p className="eyebrow" data-testid="footer-disclaimer">Review assistance only. Not legal, tax or financial advice.</p>
    </div>
  </footer>
);
